"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const RecordNotFoundError_1 = require("../errors/RecordNotFoundError");
const UnauthorizedError_1 = require("../errors/UnauthorizedError");
const UnprocessableError_1 = require("../errors/UnprocessableError");
function handleApiError(_target, _key, descriptor) {
    const fn = descriptor.value;
    const newFn = function newFn(...args) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                return yield fn.apply(this, args);
            }
            catch (err) {
                const error = err;
                if (axios_1.default.isAxiosError(error)) {
                    if (!error.response) {
                        throw error;
                    }
                    const { response } = error;
                    const { status, data } = response;
                    const message = error.message || 'Unknown error';
                    const errors = (_a = data.errors) !== null && _a !== void 0 ? _a : [];
                    if (status === 404) {
                        throw new RecordNotFoundError_1.RecordNotFoundError(message, errors);
                    }
                    else if (status === 422) {
                        throw new UnprocessableError_1.UnprocessableError(message, errors);
                    }
                    else if (status === 401) {
                        throw new UnauthorizedError_1.UnauthorizedError(message, errors);
                    }
                    throw new Error(message);
                }
                throw error;
            }
        });
    };
    descriptor.value = newFn;
    return descriptor;
}
exports.default = handleApiError;
//# sourceMappingURL=handleApiError.js.map